<template>
  <div>
    <h1>Regalos</h1>

    <v-text-field
      outlined
      dense
      prepend-inner-icon="mdi-magnify"
      label="search"
      hide-details
      v-model="searchText"
    ></v-text-field>

    <!-- group filter -->
    <div>
      <div v-if="loading1">
        <div v-if="loading1" style="margin-top: 8px; display: flex; gap: 8px; margin-left: 5px">
          <v-skeleton-loader type="chip"></v-skeleton-loader>
          <v-skeleton-loader type="chip"></v-skeleton-loader>
          <v-skeleton-loader type="chip"></v-skeleton-loader>
        </div>
      </div>
      <v-chip-group v-else>
        <v-chip
          v-for="group in groupsList"
          class="mr-1"
          :key="group.value"
          :outlined="groupFilter != group.value"
          @click="groupFilter = groupFilter == group.value ? '' : group.value"
          >{{ group.text }}</v-chip
        >
      </v-chip-group>
    </div>

    <!-- high level stats-->
    <div v-if="false">
      <div v-if="loading1" style="margin-top: 5px; display: flex; gap: 8px; margin-bottom: 5px; margin-left: 5px">
        <v-skeleton-loader type="chip"></v-skeleton-loader>
        <v-skeleton-loader type="chip"></v-skeleton-loader>
        <v-skeleton-loader type="chip"></v-skeleton-loader>
      </div>
      <v-chip-group v-else>
        <v-chip>Campañas: {{ filteredList.filter((c) => c.completed).length }}/{{ filteredList.length }}</v-chip>

        <v-chip>Gasto total: {{ spentTotal() }}€</v-chip>
        <v-chip>Presupuesto total: {{ filteredList.map((c) => c.budget).reduce((a, b) => +a + +b, 0) }}€</v-chip>
      </v-chip-group>
    </div>

    <!--loading indicator-->
    <div v-if="loading1 && !my_data" style="text-align: center; margin-top: 20px">
      <v-progress-circular indeterminate size="60"></v-progress-circular>
      <p>Cargando</p>
    </div>
    <!-- placeholder skeleton per campaign -->
    <div v-else-if="loading1 && my_data">
      <div v-for="c in my_data.campaigns" :key="c">
        <v-skeleton-loader v-bind="attrs" type="article, divider"></v-skeleton-loader>
      </div>
    </div>
    <!-- list campaigns -->
    <div v-else>
      <div v-for="campaign in filteredList" :key="campaign.id">
        <div
          style="
            margin-bottom: 5px;
            padding: 10px;
            border-bottom: 1px solid #ccc;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            gap: 5px;
            width: 100%;
          "
          @click="$router.push(`/regalos/campaign/${campaign.id}`)"
        >
          <!-- col 1-->
          <div>
            <div style="font-size: 120%; font-weight: bold">
              {{ campaign.title }}
            </div>
            <div v-if="false && campaign.description">
              {{ campaign.description }}
            </div>

            <div>
              <!-- count of products -->
              <div>
                {{ campaign.ideas.filter((i) => i.completed).length }} ideas gestionadas,
                {{ campaign.ideas.filter((i) => !i.completed && !i.discarded).length }} abiertas
              </div>
              <!-- spent vs budget -->
              <div>
                {{ spentCampaign(campaign) }}€ <span v-if="campaign.budget"> / {{ campaign.budget }}€</span>
                <span v-if="campaign.budget" :style="{ color: remainingBudget(campaign) > 0 ? 'green' : 'red' }">
                  ({{ remainingBudget(campaign) }}€)
                </span>
              </div>
            </div>
          </div>
          <!-- col 2-->
          <div>
            <div v-if="campaign.completed">
              <v-chip color="success">Completado</v-chip>
            </div>

            <!-- progress graphs -->
            <div v-if="false" style="display: flex; justify-content: right; gap: 5px">
              <div>
                <div>Ideas</div>
                <v-progress-circular
                  :rotate="-90"
                  :size="70"
                  :width="8"
                  :value="completedIdeasPerc(campaign)"
                  color="teal"
                >
                  <span style="font-size: 120%"> {{ campaign.ideas.filter((i) => i.completed).length }} </span>
                  <span style="font-size: 90%">/{{ campaign.ideas.length }}</span>
                </v-progress-circular>
              </div>
              <div>
                <div>Budget</div>
                <v-progress-circular
                  :rotate="-90"
                  :size="70"
                  :width="8"
                  :value="remainingBudgetPerc(campaign)"
                  color="teal"
                >
                  <span style="font-size: 110%"> {{ remainingBudget(campaign) }}€ </span>
                </v-progress-circular>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--add button-->
      <v-fab-transition>
        <v-btn
          fab
          bottom
          right
          fixed
          color="success"
          @click="addCampaign"
          :loading="loading1"
          style="margin-bottom: 56px"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'
import utils from '@/assets/utils'
import { v4 as uuidv4 } from 'uuid'
import { groups } from './regalos-data'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      searchText: '',
      loading1: false,
      campaigns: [],
      my_data: {},
      groupFilter: '',
    }
  },
  watch: {
    groupFilter(newValue, oldValue) {
      localStorage.setItem('regalos_group_filter', newValue)
    },
  },
  computed: {
    ...mapGetters(['username']),
    filteredList() {
      if (!this.campaigns) return []

      let x = [...this.campaigns]
      x = x.filter((campaign) => utils.search.searchMatch(this.searchText, campaign.title))
      if (this.groupFilter) x = x.filter((campaign) => (campaign.group || 'N/A') === this.groupFilter)

      return x
    },
    groupsList() {
      const x = []
      let campaigns = [...this.campaigns] || []
      //sort campaigns by modified date desc
      campaigns = campaigns.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      for (let i = 0; i < campaigns.length; i++) {
        const c = campaigns[i]

        const v = c.group || 'N/A'
        let group = groups('').find((gr) => gr.value === v)
        if (!group) group = { value: v, text: v }
        const index = x.findIndex((g) => g.value === group.value)
        if (index === -1) x.push(group)
      }
      return x
    },
  },
  methods: {
    spentTotal() {
      let spent = 0

      for (let i = 0; i < this.filteredList.length; i++) {
        const campaign = this.filteredList[i]
        spent += this.spentCampaign(campaign)
      }
      return Math.round(spent * 100) / 100
    },
    completedIdeasPerc(campaign) {
      let completed = 0
      let total = campaign.ideas.length
      for (let i = 0; i < campaign.ideas.length; i++) {
        const idea = campaign.ideas[i]
        if (idea.completed) completed++
      }

      return Math.round((completed / total) * 100)
    },
    remainingBudgetPerc(campaing) {
      const remaining = this.remainingBudget(campaing)
      const budget = campaing.budget
      return Math.round((remaining / budget) * 100)
    },
    remainingBudget(campaign) {
      let remaining = campaign.budget
      for (let i = 0; i < campaign.ideas.length; i++) {
        const idea = campaign.ideas[i]
        for (let j = 0; j < idea.options.length; j++) {
          const option = idea.options[j]
          if (option.purchased) remaining -= option.price
        }
      }
      return Math.round(remaining * 100) / 100
    },
    spentCampaign(campaign) {
      let spent = 0
      for (let i = 0; i < campaign.ideas.length; i++) {
        const idea = campaign.ideas[i]
        for (let j = 0; j < idea.options.length; j++) {
          const option = idea.options[j]
          if (option.purchased) spent += +option.price
        }
      }
      return Math.round(spent * 100) / 100 //
    },

    async fetchCampaigns() {
      this.loading1 = true
      let x = await api.apiFetch('/regalos/campaigns', {
        method: 'GET',
      })
      if (!x.ok) return alert('Error fetching campaigns...')
      const j = await x.json()
      this.my_data = j

      const campaignPromises = j.campaigns.map((campaign_id) =>
        api
          .apiFetch(`/regalos/campaign?id=${campaign_id}`)
          .then((y) => (y.ok ? y.json() : null))
          .catch(() => {
            console.warn("couldn't fetch " + campaign_id)
            return null
          })
      )

      const campaignResults = await Promise.all(campaignPromises)
      const campaigns = campaignResults.filter((campaign) => campaign !== null)

      this.campaigns = campaigns.sort((a, b) => {
        return new Date(b.updatedAt) - new Date(a.updatedAt)
      })
      this.loading1 = false
    },
    async addCampaign() {
      //TODO
      this.loading1 = true
      const new_id = uuidv4()
      let x = await api.apiFetch('/regalos/campaign', {
        method: 'POST',
        body: JSON.stringify({
          id: new_id,
          title: 'Nueva campaña',
          owners: [this.username],
          description: 'Created at ' + new Date().toISOString(),
          budget: '',
          active: '',
        }),
      })
      this.loading1 = false
      if (!x.ok) return alert('Error creating the campaign...')
      //route to the edit page
      this.$router.push(`/regalos/campaign/${new_id}/edit`)
    },
  },
  mounted() {
    this.fetchCampaigns()
    const g = localStorage.getItem('regalos_group_filter')
    if (g) this.groupFilter = g
  },
}
</script>

<style scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
